<template>
    <span v-b-tooltip.hover class="patient-id" :title="`${$translate('patient')} ${patientId}`">
        {{ patientId }}
    </span>
</template>

<script>
export default {
    name: 'PatientId',
    props: {
        patient: {
            type: Object,
            required: true
        },
        vendor: {
            type: String,
            required: true
        }
    },
    computed: {
        patientId() {
            return this.$utils.getPatientEsIdByVendor(this.vendor, this.patient)
        }
    }
}
</script>

<style>
.patient-id {
    cursor: pointer;
}
</style>
